import {Component, Input} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { RdContact } from '../objects/user';
import { RdstationService } from '../services/rdstation.service';
import { SlideInOutAnimation } from '../objects/animation';
import { FormsService } from '../services/forms.service';

@Component({
  selector: 'app-stay-connected',
  templateUrl: './stay-connected.component.html',
  styleUrls: ['./stay-connected.component.scss'],
  animations: [SlideInOutAnimation]
})
export class StayConnectedComponent {
  form: UntypedFormGroup;
  news: UntypedFormGroup;
  contact: RdContact;
  newsEmail: string;
  formNews: RdContact;
  animationState = 'out';

  formConfig = {
    city: [null],
    email: [null, Validators.required],
    name: [null, Validators.required],
    profile: [null],
  }

  @Input() class: string = '';

  constructor(
    private f: UntypedFormBuilder,
    private rdService: RdstationService,
    private formService: FormsService,
    private router: Router
  ) {
    this.form = this.f.group(this.formConfig);
    this.news = this.f.group(this.formConfig);
  }

  toggleShowDiv(divName: string) {
    if (divName === 'news')
      this.animationState = this.animationState === 'out' ? 'in' : 'out';
  }

  public sendContact(form, rdStation = false): void {
    if (form.valid) {
      if (rdStation) {
        this.contact = form.value;
        this.rdService.createContact(this.contact).subscribe((response: any) => {
          this.router.navigate(['success', 'stay-connected']);
        });
      } else {
        const data = form.value;
        this.formService.postFormContact(data)
          .then(() => {
            this.router.navigate(['success', 'stay-connected']);
          })
      }
    }
  }
}
